var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 51,
    viewBox: "0 0 61 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.8083 26.2083L60.125 30.5558L39.9908 50.875L29.2917 40.0833L33.6083 35.7358L39.9908 42.1492L55.8083 26.2083ZM21.5833 40.0833L30.8333 49.3333H0V43.1667C0 36.3525 11.0383 30.8333 24.6667 30.8333L30.4942 31.1725L21.5833 40.0833ZM24.6667 0C27.9377 0 31.0747 1.2994 33.3876 3.61235C35.7006 5.9253 37 9.06233 37 12.3333C37 15.6043 35.7006 18.7414 33.3876 21.0543C31.0747 23.3673 27.9377 24.6667 24.6667 24.6667C21.3957 24.6667 18.2586 23.3673 15.9457 21.0543C13.6327 18.7414 12.3333 15.6043 12.3333 12.3333C12.3333 9.06233 13.6327 5.9253 15.9457 3.61235C18.2586 1.2994 21.3957 0 24.6667 0Z",
    fill: "#204269"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.c0b464c7d9429587b2b55544f75cfbb3.svg";
export { ForwardRef as ReactComponent };